export default "__VITE_ASSET__CQiYTDNs__"